var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhitelogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166.663,
    height: 56.973,
    viewBox: "0 0 166.663 56.973",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_768",
    "data-name": "Group 768",
    transform: "translate(-225.066 -283.356)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1568",
    "data-name": "Path 1568",
    d: "M476.032,295.887l1.35,21.741,6.356,4.1s6.557,1.226,7.241,1.109,7.345-4.581,7.345-4.581l3.577-8.89v-8.112l-3.853-5.367-5.021-3.531-1.034-1.463-3.925-1.208Z",
    transform: "translate(-144.198 -3.636)",
    fill: "#90ce3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1569",
    "data-name": "Path 1569",
    d: "M227.19,298.523a14.918,14.918,0,0,1,5.585-5.094,17,17,0,0,1,7.74-1.633q6.662,0,9.862,2.907t3.2,9.96v19.725h-4.964l-.98-1.7a15.8,15.8,0,0,1-9.34,2.743,26.019,26.019,0,0,1-5.16-.587,9.978,9.978,0,0,1-7.185-5.682,9.838,9.838,0,0,1-.881-4.245,10.954,10.954,0,0,1,.914-4.245,9.967,9.967,0,0,1,2.645-3.56,9.845,9.845,0,0,1,4.441-2.123,38.764,38.764,0,0,1,4.311-.816q2.219-.294,4.18-.653a23.409,23.409,0,0,0,3.462-.882,3.744,3.744,0,0,0,2.09-1.5,9.134,9.134,0,0,0-2.156-5.65q-1.829-1.925-5.551-1.927a12.8,12.8,0,0,0-3.625.49,11.788,11.788,0,0,0-3,1.339,12.81,12.81,0,0,0-2.351,1.894,14.169,14.169,0,0,0-1.731,2.155ZM247.176,320.8v-17.83a15.909,15.909,0,0,1-4.017,1.829q-2.319.719-5.649,1.633a8.108,8.108,0,0,0-3.723,2.155,8.854,8.854,0,0,0-2.057,3.4,9.995,9.995,0,0,0-.457,3.952,9.72,9.72,0,0,0,1.045,3.755,8.2,8.2,0,0,0,2.417,2.841,6.33,6.33,0,0,0,3.69,1.209,19.316,19.316,0,0,0,4.7-.555A8.666,8.666,0,0,0,247.176,320.8Z",
    transform: "translate(0 -4.849)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1570",
    "data-name": "Path 1570",
    d: "M348.376,285.508c-.74-.388-1.457-.749-2.156-1.074s-1.435-.685-2.22-1.078a21.353,21.353,0,0,1-1.859,3.523,14.7,14.7,0,0,1-2.91,3.334,16.468,16.468,0,0,0-5.256-2.973,20.553,20.553,0,0,0-6.889-1.078,18.373,18.373,0,0,0-10.029,2.549,17.044,17.044,0,0,0-6.073,6.4,18.012,18.012,0,0,0-.131,16.589,16.465,16.465,0,0,0,6.041,6.4,18.8,18.8,0,0,0,10.191,2.549,20.222,20.222,0,0,0,8.1-1.5,16.662,16.662,0,0,0,5.716-3.952,16.071,16.071,0,0,0,3.361-5.585,17.9,17.9,0,0,0,1.047-6.366,18.321,18.321,0,0,0-1.277-6.334,16.3,16.3,0,0,0-3.56-5.522,37.415,37.415,0,0,0,4.413-2.576A14.878,14.878,0,0,0,348.376,285.508ZM336.817,310.98a13.963,13.963,0,0,1-3.465,5.784,8.2,8.2,0,0,1-6,2.319,8.724,8.724,0,0,1-6.239-2.319,14.028,14.028,0,0,1-3.627-5.784,22.332,22.332,0,0,1-1.11-7.543,23.294,23.294,0,0,1,1.309-7.543,14.969,14.969,0,0,1,3.622-5.779,8.366,8.366,0,0,1,11.563,0,14.969,14.969,0,0,1,3.622,5.779,23.8,23.8,0,0,1,1.34,7.543A22.684,22.684,0,0,1,336.817,310.98Z",
    transform: "translate(-48.166)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1571",
    "data-name": "Path 1571",
    d: "M316.609,386.1a5.381,5.381,0,0,1-2.6-.946,9.281,9.281,0,0,1-2.7-3.062,7.986,7.986,0,0,1-1.045-4.866,6.42,6.42,0,0,1,2.351-4.18q2.057-1.763,6.107-1.763H334.52a15.541,15.541,0,0,0,4.768-.621A5.656,5.656,0,0,0,342,369.03a2.354,2.354,0,0,0,.457-2.253,5.455,5.455,0,0,0-1.992-2.547q.784-.523,1.437-1.045a9.526,9.526,0,0,1,3.854,4.18,7.1,7.1,0,0,1,.327,5.094,6.6,6.6,0,0,1-3,3.691,12.4,12.4,0,0,1-6.466,1.4H321.13a10.433,10.433,0,0,0-4.67.784,3.305,3.305,0,0,0-1.8,1.96,4.02,4.02,0,0,0,.2,2.547l.011.027a5.369,5.369,0,0,0,4.184,3.163,6.655,6.655,0,0,0,1.364.061A18.67,18.67,0,0,1,316.609,386.1Z",
    transform: "translate(-48.917 -45.868)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1572",
    "data-name": "Path 1572",
    d: "M433.479,291.378q-.2,1.175-.457,2.319t-.523,2.384a6.678,6.678,0,0,0-3.527-.719,15.4,15.4,0,0,0-2.743.262,13.592,13.592,0,0,0-2.776.816,10.881,10.881,0,0,0-2.449,1.4,5.8,5.8,0,0,0-1.7,2.025V324.1h-6.4V291.509l4.506-.066,1.829,3.527.065,2.873a13.181,13.181,0,0,1,4.245-4.7,12.52,12.52,0,0,1,7.315-1.96A18.452,18.452,0,0,1,433.479,291.378Z",
    transform: "translate(-107.927 -4.497)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1573",
    "data-name": "Path 1573",
    d: "M480.368,323.064a19.346,19.346,0,0,1-6.422-1.112,17.781,17.781,0,0,1-5.69-3.243,16.377,16.377,0,0,1-4.069-5.245,17.481,17.481,0,0,1,.032-14.5,16.052,16.052,0,0,1,4.1-5.182,17.046,17.046,0,0,1,5.69-3.083,20.569,20.569,0,0,1,12.779,0,17.065,17.065,0,0,1,5.69,3.083,16.079,16.079,0,0,1,4.1,5.182,17.481,17.481,0,0,1,.032,14.5,16.407,16.407,0,0,1-4.069,5.245,17.736,17.736,0,0,1-5.722,3.243A19.622,19.622,0,0,1,480.368,323.064Zm0-32.171a7.914,7.914,0,0,0-4.8,1.463,12.155,12.155,0,0,0-3.306,3.655,17.457,17.457,0,0,0-1.939,4.769,20.305,20.305,0,0,0-.636,4.864,21.682,21.682,0,0,0,.668,5.817,19.177,19.177,0,0,0,2.1,5.182,11.78,11.78,0,0,0,3.369,3.688,7.748,7.748,0,0,0,4.546,1.4,7.505,7.505,0,0,0,4.45-1.4,12.694,12.694,0,0,0,3.4-3.688,18.042,18.042,0,0,0,2.162-5.182,23.687,23.687,0,0,0,.731-5.817,21.344,21.344,0,0,0-.6-4.864,17.369,17.369,0,0,0-1.876-4.769,11.64,11.64,0,0,0-3.306-3.655A8.275,8.275,0,0,0,480.368,290.893Z",
    transform: "translate(-136.497 -3.636)",
    fill: "#90ce3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1574",
    "data-name": "Path 1574",
    d: "M556.153,317.349a10.389,10.389,0,0,0,2.289,1.431,22.939,22.939,0,0,0,3.02,1.176,23.787,23.787,0,0,0,3.433.795,22.578,22.578,0,0,0,3.528.286,14.685,14.685,0,0,0,3.815-.477,6.377,6.377,0,0,0,2.925-1.621,3.288,3.288,0,0,0,.6-.922,4.5,4.5,0,0,0,.382-1.4,4.252,4.252,0,0,0-.127-1.621,2.875,2.875,0,0,0-.985-1.462,11.2,11.2,0,0,0-3.211-2.035q-1.812-.763-3.751-1.367t-3.878-1.208a18.293,18.293,0,0,1-3.529-1.494,9.159,9.159,0,0,1-3.879-3.783,8.44,8.44,0,0,1-.953-4.578,8.537,8.537,0,0,1,1.621-4.323,8.88,8.88,0,0,1,3.783-3.02,14.56,14.56,0,0,1,3.083-.858,21.014,21.014,0,0,1,3.529-.286,24.32,24.32,0,0,1,6.676.922,11.488,11.488,0,0,1,5.086,2.766l-1.144,1.272a12.669,12.669,0,0,0-4.991-2.448,23.662,23.662,0,0,0-5.563-.667,8.765,8.765,0,0,0-4.546,1.113,5.3,5.3,0,0,0-2.448,2.7,3.946,3.946,0,0,0,.381,3.338,7.444,7.444,0,0,0,4.006,2.956q1.652.636,3.052,1.081t2.7.795q1.3.35,2.511.731a22.428,22.428,0,0,1,2.353.89,9.335,9.335,0,0,1,4.323,3.751,8.277,8.277,0,0,1,1.112,4.641,9.165,9.165,0,0,1-1.494,4.418,8.316,8.316,0,0,1-3.5,3.083,14.955,14.955,0,0,1-3.751,1.208,22.411,22.411,0,0,1-4.133.382,23.49,23.49,0,0,1-7.407-1.208,15.207,15.207,0,0,1-5.944-3.433Z",
    transform: "translate(-189.65 -4.152)",
    fill: "#90ce3e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_762",
    "data-name": "Group 762",
    transform: "translate(341.863 292.928)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_760",
    "data-name": "Group 760",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1575",
    "data-name": "Path 1575",
    d: "M504.939,308.017c-1.454.844-5.525,3.485-5.325,7.948a10.421,10.421,0,0,0,1.594,5.628,12.164,12.164,0,0,0,5.924-2.776,7.8,7.8,0,0,0,2.417-7.923,13.778,13.778,0,0,1-.428-5.037S506.487,307.12,504.939,308.017Z",
    transform: "translate(-499.607 -305.857)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1576",
    "data-name": "Path 1576",
    d: "M511.832,310.894a25.049,25.049,0,0,1-.428-5.037,41.911,41.911,0,0,0-4.592,6.985,26.5,26.5,0,0,0-2.11,4.889c-.288.9-.564,1.8-.813,2.7-.1.371-.2.761-.311,1.144a12.134,12.134,0,0,0,5.836-2.762A7.8,7.8,0,0,0,511.832,310.894Z",
    transform: "translate(-501.889 -305.857)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_761",
    "data-name": "Group 761",
    transform: "translate(1.073 4.635)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1577",
    "data-name": "Path 1577",
    d: "M503.1,328.382a47.085,47.085,0,0,1,4.789-11.631",
    transform: "translate(-502.687 -316.751)",
    fill: "#aad13d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1578",
    "data-name": "Path 1578",
    d: "M502.13,328.28c.3-1.031.646-2.026,1.015-3.021s.769-1.972,1.2-2.938.89-1.917,1.383-2.849,1.038-1.837,1.608-2.72c-.51.921-.993,1.853-1.418,2.814s-.824,1.929-1.178,2.915-.687,1.979-.986,2.981-.57,2.018-.794,3.023Z",
    transform: "translate(-502.13 -316.751)",
    fill: "#aad13d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_764",
    "data-name": "Group 764",
    transform: "translate(335.651 300.77)",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_763",
    "data-name": "Group 763",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1579",
    "data-name": "Path 1579",
    d: "M485.2,329.694c-.286,1.947-.831,7.6,3.4,10.669,3.6,2.607,6.317,2.638,6.317,2.638a14.238,14.238,0,0,0,1.772-7.451,9.131,9.131,0,0,0-5.5-7.986c-3.808-1.9-4.928-3.276-4.928-3.276S485.5,327.623,485.2,329.694Z",
    transform: "translate(-485.006 -324.289)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1580",
    "data-name": "Path 1580",
    d: "M492.89,327.565a29.386,29.386,0,0,1-4.928-3.276,49.011,49.011,0,0,0,3.057,9.294,30.957,30.957,0,0,0,2.943,5.5c.613.916,1.234,1.825,1.885,2.715.266.363.555.733.822,1.118a14.2,14.2,0,0,0,1.72-7.359A9.132,9.132,0,0,0,492.89,327.565Z",
    transform: "translate(-486.704 -324.289)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1581",
    "data-name": "Path 1581",
    d: "M499.568,352.061A55.126,55.126,0,0,1,492.4,339.2",
    transform: "translate(-489.253 -332.858)",
    stroke: "#82d33c",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_766",
    "data-name": "Group 766",
    transform: "translate(335.239 300.77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_765",
    "data-name": "Group 765",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1582",
    "data-name": "Path 1582",
    d: "M484.227,329.694c-.286,1.947-.831,7.6,3.4,10.669,3.6,2.607,6.317,2.638,6.317,2.638a14.242,14.242,0,0,0,1.772-7.451,9.132,9.132,0,0,0-5.5-7.986c-3.808-1.9-4.928-3.276-4.928-3.276S484.532,327.623,484.227,329.694Z",
    transform: "translate(-484.036 -324.289)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1583",
    "data-name": "Path 1583",
    d: "M491.92,327.565a29.358,29.358,0,0,1-4.928-3.276,49.019,49.019,0,0,0,3.057,9.294,30.989,30.989,0,0,0,2.943,5.5c.613.916,1.235,1.825,1.886,2.715.265.363.555.733.822,1.118a14.207,14.207,0,0,0,1.72-7.359A9.132,9.132,0,0,0,491.92,327.565Z",
    transform: "translate(-485.734 -324.289)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1584",
    "data-name": "Path 1584",
    d: "M498.26,352.321c-.726-1.023-1.394-2.058-2.041-3.115s-1.256-2.133-1.835-3.224-1.118-2.2-1.619-3.332-.938-2.283-1.338-3.447c.467,1.14.964,2.265,1.53,3.356s1.156,2.167,1.8,3.213,1.3,2.079,2,3.086,1.425,2,2.18,2.944Z",
    transform: "translate(-488.283 -332.858)",
    fill: "#90ce3e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitelogo);
export default __webpack_public_path__ + "static/media/whitelogo.576dc2add0df47d12682ce5ff544f729.svg";
export { ForwardRef as ReactComponent };